import { render, staticRenderFns } from "./CommunicationReceivers.vue?vue&type=template&id=8d007a86"
import script from "./CommunicationReceivers.vue?vue&type=script&lang=js"
export * from "./CommunicationReceivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports